import { arrayOf, func, string } from 'prop-types';
import React from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import createModalToggle from '../../../../generic/create-modal-toggle';
import DateRange from '../../../../generic/DateRange';
import getEventTargetValue from '../../../../utils/get-event-target-value';

class BulkEditBookingEntriesModal extends React.Component {
  state = {
    serviceStartDate: null,
    serviceEndDate: null,
  };

  handleChange = e => {
    const { name } = e.target;
    const value = getEventTargetValue(e.target);
    this.setState({
      [name]: value,
    });
  };

  handleSave = async () => {
    const { selectedEntryIds, onUpdate, onSuccess } = this.props;

    await Promise.all(selectedEntryIds.map(id => onUpdate(id, this.state)));
    onSuccess();
  };

  render() {
    const { toggle } = this.props;
    const { serviceEndDate, serviceStartDate } = this.state;
    return (
      <>
        <ModalHeader toggle={toggle}>Edit entries</ModalHeader>
        <ModalBody>
          <DateRange
            startName="serviceStartDate"
            endName="serviceEndDate"
            startDate={serviceStartDate}
            endDate={serviceEndDate}
            onChange={this.handleChange}
            small
          />
          <div className="mb-2" />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.handleSave}>
            Save
          </Button>
        </ModalFooter>
      </>
    );
  }
}

BulkEditBookingEntriesModal.propTypes = {
  toggle: func.isRequired,
  onSuccess: func.isRequired,
  onUpdate: func.isRequired,
  selectedEntryIds: arrayOf(string.isRequired).isRequired,
};

const BulkEditBookingEntries = createModalToggle(
  'Edit selected entries',
  BulkEditBookingEntriesModal,
  { outline: true },
);

export default BulkEditBookingEntries;
